import { atom } from "recoil";

export const pausedActivities = atom({
  key: " pausedActivities",
});
